import { Tenant } from './Tenant';
import { Platform } from './Platform';
export { Tenant, Platform };
export var modelList = [Tenant, Platform];
